import { useEffect, useState } from "react"
import Select from 'react-select'

export default function SearchStuff({data, field, label, type, setState, name, isSelect, options, selectPlaceholder, filterOptions, setFilterOptions, useValue, isInvoice}) {
  const [value, setValue] = useState('')
  const [selectValue, setSelectValue] = useState(null)
  
  const handleChange = (e) => {
    setSelectValue(null)
    setValue(e.target.value)
    Object.keys(filterOptions).forEach(key => {
      if (key !== e.target.id) {
        setFilterOptions(prev => ({
          ...prev,
          [key]: '',
        }))
      }
    })
    setFilterOptions(prev => ({
      ...prev,
      [e.target.id]: e.target.value
    }))
  }

  const handleSelect = (o, e) => {
    setValue('')
    setSelectValue(o)
    Object.keys(filterOptions).forEach(key => {
      if (key !== e.name) {
        setFilterOptions(prev => ({
          ...prev,
          [key]: ''
        }))
      }
    })
    setFilterOptions(prev => ({
      ...prev,
      [e.name]: o
    }))
  }
  
  useEffect(() => {
    if (data) {
      let newValue
      if (!isSelect) {
        newValue = data.filter(x => x[field] === (type === 'number' ? parseInt(value) : value))
      } else if (isSelect && options) {
        if (!useValue) {
          newValue = data.filter(x => x[field] === selectValue?.label)
        } else {
          newValue = data.filter(x => !isInvoice ? (x[field] === selectValue?.value) : selectValue?.label !== "All" && (`${x.is_account_invoice}` === selectValue?.value.split("-")[1] && x[field] === parseInt(selectValue?.value.split("-")[0])))
        }
      }
      if (value === "" && selectValue?.label === "All") {
        setState([])
      } else if (useValue && selectValue?.value === 0 && value === "") {
        setState([])
      } else {
        setState(newValue)
      }
    }    
  }, [value, setState, data, isSelect, field, type, options, selectValue, useValue, setSelectValue, isInvoice])

  return (
    <div className="col-auto">
      {
        !isSelect ? 
        <input 
        type={type}
        placeholder={label}
        onChange={handleChange}
        value={filterOptions[name]}
        id={name}
      /> :
      <Select 
        key={name}
        name={name}
        options={options}
        onChange={handleSelect}
        placeholder={selectPlaceholder}
        value={filterOptions[name]}
        className="search-select"
      />
      }
    </div>
  )
}